<div class="outer-container">
    <div fxLayout="row" fxLayoutGap="2" fxLayoutAlign="space-around top">
        <div fxFlex="75">
            <div class="top">
                <div class="high-value-title">
                    <span class="subhead">{{ title }}</span>
                </div>
                <span class="chartHead">Top 10 By {{ header }}</span>
                <div echarts [options]="top" class="chart"></div>
            </div>
            <div class="bottom">
                <span class="chartHead">Bottom 10 By {{ header }}</span>
                <div echarts [options]="bottom" class="chart"></div>
            </div>
        </div>
        <div fxFlex="23">
            <div class="top">
                <div class="radio-title">
                    <span class="subhead"> {{ title }} By </span>
                </div>
                <mat-radio-group #group="matRadioGroup" class="radiogrp" [value]="radio">
                    <mat-radio-button value="ecc_major" (change)="searchDimension($event.value)">
                        DW-1-Digit Att
                    </mat-radio-button>

                    <mat-radio-button value="part_number" *ngIf="flag == 'nrp'" (change)="searchDimension($event.value)">
                        Parts
                    </mat-radio-button>

                    <mat-radio-button value="certification" (change)="searchDimension($event.value)">
                        Channel Code
                    </mat-radio-button>

                    <mat-radio-button *ngIf="flag == 'nrp'" value="country" (change)="searchDimension($event.value)">
                        Country
                    </mat-radio-button>

                    <mat-radio-button value="ecc" (change)="searchDimension($event.value)">
                        DW-3-Digit Att
                    </mat-radio-button>

                    <!-- <mat-radio-button value="manufacturer" *ngIf="flag == 'nrp'"
                        (change)="searchDimension($event.value)">
                        Manufacturer
                    </mat-radio-button> -->
                    <mat-radio-button *ngIf="flag == 'cssna'" value="lob_l2" (change)="searchDimension($event.value)">
                        LOB - L2
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="bottom">
                <div class="example-container mat-elevation-z8">
                    <table mat-table [dataSource]="dataSource">
                        <!-- Item Column -->
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>{{ header }}</th>
                            <td mat-cell *matCellDef="let dataSource">
                                {{ dataSource.name }}
                            </td>
                            <td mat-footer-cell *matFooterCellDef>Total</td>
                        </ng-container>

                        <!-- Cost Column -->
                        <ng-container matColumnDef="price">
                            <th mat-header-cell *matHeaderCellDef>{{ title }}</th>
                            <td mat-cell *matCellDef="let dataSource">
                                {{ dataSource.price | dollar }}
                            </td>
                            <td mat-footer-cell *matFooterCellDef>{{ total | dollar }}</td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>